export const pipe =
  (...fns: ((i: any) => any)[]) =>
  (x: any) =>
    fns.reduce((v, f) => f(v), x)
